import { useEffect, useMemo, useRef, useState } from "react";
import { MainWrapper } from "../component/MainWrapper";
import { toAbsoluteUrl } from "sr/helpers";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { getFiles } from "sr/utils/api/getFiles";
import { getFile } from "sr/utils/api/getFile";
import { DateFormat } from "sr/helpers/functions/DateFormat";
import { getJob } from "sr/utils/api/individual/job/getJob";
import Job from "app/pages/component/types/individual/job";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import getStripCustomerId from "sr/helpers/apiFunctions/strip/getStripCustomerId";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { getCardIcon } from "sr/helpers/functions/getCardIcon";
import { getIndividual } from "sr/utils/api/individual/getIndividual";
import { useGet } from "app/pages/company/Hooks/Api/useGet";
import { useSocket } from "app/pages/component/SocketContext";
import { StringTimeFormat } from "sr/helpers/functions/StringTimeFormat";
import { addJob } from "sr/utils/api/individual/job/addJob";
import { updateJob } from "sr/utils/api/individual/job/updateJob";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "sr/redux/store";
import { getFeeTransparency } from "sr/utils/api/fee/getFeeTransparency";
import { FeeBreakdownBox } from "app/pages/component/FeeBreakdownBox";
export const Confirm = () => {
  const intl = useIntl();
  const [profileImg, setProfileImg] = useState<string>();
  const [cleanerData, setCleanerData] = useState<any>();
  const [jobId, setJobId] = useState<string>();
  const [loader, setLoader] = useState<string>("");
  const [data, setData] = useState<Job>();
  const [jobDraft, setJobDraft] = useState<any>();
  const [selectedStartTime, setSelectedStartTime] = useState<string>();
  const [selectedEndTime, setSelectedEndTime] = useState<string>();
  const [selectedRate, setSelectedRate] = useState<number>();
  const [cardDetails, setCardDetails] = useState<any>([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [stripId, setStripId] = useState();
  const [userId, setUserid] = useState();
  const { loader: userloader, getData: fetchData, data: userData } = useGet();
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<any>(null);
  const [feeTransparency, setFeeTransparency] = useState<any>(null);
  const [feeTransparencyLoading, setFeeTransparencyLoading] = useState(false);
  const feeTransparencyReqIdRef = useRef(0);
  const [showPaymentDropdown, setShowPaymentDropdown] = useState(false);
  const paymentDropdownRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const appSettingsData = useSelector((s: RootState) => s.appSettings.data);
  const location = useLocation();

  useEffect(() => {
    const state: any = location?.state;
    if (state?.jobDraft) {
      setJobDraft(state.jobDraft);
    }
    if (state?.selectedCleaner) {
      setCleanerData(state.selectedCleaner);
    }
    if (state?.startSelectedTime) {
      setSelectedStartTime(state.startSelectedTime);
    }
    if (state?.endSelectedTime) {
      setSelectedEndTime(state.endSelectedTime);
    }
    if (state?.rate !== undefined) {
      setSelectedRate(state.rate);
    }
    if (state?.profileImg) {
      setProfileImg(state.profileImg);
    }
  }, [location?.state]);

  useEffect(() => {
    const { user_id } = getUserDetails();
    setUserid(user_id);
  }, []);
  useEffect(() => {
    const fetchDetails = async (userId) => {
      const queryParams = new URLSearchParams();
      if (userId) queryParams.append("id", userId);
      await fetchData(() => getIndividual(queryParams));
    };
    if (userId) {
      fetchDetails(userId);
    }
  }, [userId]);
  const params = useParams();
  useEffect(() => {
    const { id } = params;
    const safeId = id && id !== "undefined" ? id : "draft";
    setJobId(safeId);
  }, [params]);
  const fetchJobData = async () => {
    const queryParams = new URLSearchParams();
    queryParams.append("id", jobId);
    setLoader("JobData");
    try {
      const res = await getJob(queryParams);
      if (res?.success === true) {
        setData(res?.data);
        if (res?.data?.cleaner_id) {
          setCleanerData(res?.data?.cleaner_id);
        }
        setLoader("");
      } else {
        setLoader("");
      }
    } catch (e) {
      setLoader("");
    }
  };
  useEffect(() => {
    if (jobId && jobId !== "draft" && jobId !== "undefined") {
      fetchJobData();
    } else if (jobDraft) {
      setData(jobDraft);
    }
  }, [jobId, jobDraft]);

  const resolvedCleaner = useMemo(
    () => cleanerData || (data as any)?.cleaner_id,
    [cleanerData, data],
  );
  const resolvedStartTime = useMemo(
    () => selectedStartTime || data?.start_time || jobDraft?.from,
    [selectedStartTime, data?.start_time, jobDraft?.from],
  );
  const resolvedEndTime = useMemo(
    () => selectedEndTime || (data as any)?.end_time || jobDraft?.to,
    [selectedEndTime, (data as any)?.end_time, jobDraft?.to],
  );
  const resolvedRate = useMemo(
    () => selectedRate ?? data?.rate ?? jobDraft?.rate,
    [selectedRate, data?.rate, jobDraft?.rate],
  );

  useEffect(() => {
    const amount = Number(resolvedRate);
    if (
      !amount ||
      Number.isNaN(amount) ||
      amount <= 0 ||
      !resolvedStartTime ||
      !resolvedEndTime
    ) {
      setFeeTransparency(null);
      setFeeTransparencyLoading(false);
      return;
    }
    (async () => {
      const reqId = feeTransparencyReqIdRef.current + 1;
      feeTransparencyReqIdRef.current = reqId;
      setFeeTransparencyLoading(true);
      try {
        const res = await getFeeTransparency({
          jobType: "individual",
          amount,
          start_time: resolvedStartTime,
          end_time: resolvedEndTime,
        });
        if (reqId !== feeTransparencyReqIdRef.current) return;
        if (res?.success === true) {
          setFeeTransparency(res?.data || null);
        } else {
          setFeeTransparency(null);
        }
      } catch (e) {
        if (reqId !== feeTransparencyReqIdRef.current) return;
        setFeeTransparency(null);
      } finally {
        if (reqId !== feeTransparencyReqIdRef.current) return;
        setFeeTransparencyLoading(false);
      }
    })();
  }, [resolvedRate, resolvedStartTime, resolvedEndTime]);
  const fetchProfileImg = async (cleanerId) => {
    setLoader("profileimg");
    const params = {
      cleaner_id: cleanerId,
    };
    const profileImg = await getFiles(params);
    if (profileImg?.success === true) {
      const filterfile = profileImg?.data?.filter(
        (item) => item?.file?.fieldname === "profile_img",
      );
      if (filterfile && filterfile[0]?.file?.key) {
        const fileimg = await getFile(filterfile[0]?.file?.key);
        if (fileimg) {
          const newImageUrl = URL.createObjectURL(fileimg);
          setProfileImg(newImageUrl);
          setLoader("");
        }
      }
    }
  };

  useEffect(() => {
    const cid = (resolvedCleaner as any)?._id || (resolvedCleaner as any)?.id;
    if (cid) {
      fetchProfileImg(cid);
    }
    if (userId) {
      getStripCustomerId({
        setCardDetails: setCardDetails,
        setIsProcessing: setIsProcessing,
        setStripId: setStripId,
        customerId: userId,
      });
    }
  }, [(resolvedCleaner as any)?._id, (resolvedCleaner as any)?.id, userId]);

  const socket = useSocket();

  useEffect(() => {
    if (!userId) return;
    if (socket) {
      socket.emit("register", userId);
    }
    return () => {
      socket.off("sendmessage");
    };
  }, [userId]);

  // Close the payment dropdown on outside click or Escape
  useEffect(() => {
    if (!showPaymentDropdown) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (
        paymentDropdownRef.current &&
        !paymentDropdownRef.current.contains(e.target as Node)
      ) {
        setShowPaymentDropdown(false);
      }
    };
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape") setShowPaymentDropdown(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [showPaymentDropdown]);

  const isPastStartTime = (startTime?: string, scheduleDateValue?: any) => {
    if (!startTime || !scheduleDateValue) return false;
    const scheduleDate = new Date(scheduleDateValue);
    const now = new Date();
    if (scheduleDate.toDateString() !== now.toDateString()) return false;
    const [hour = 0, minute = 0] = startTime.split(":").map(Number);
    const scheduledStart = new Date(scheduleDate);
    scheduledStart.setHours(hour, minute, 0, 0);
    return scheduledStart < now;
  };
  const toMinutes = (value?: string) => {
    if (!value) return 0;
    const [h = "0", m = "0"] = value.split(":");
    return Number(h) * 60 + Number(m);
  };

  const HandleMessage = async () => {
    const cleanerId =
      (resolvedCleaner as any)?._id || (resolvedCleaner as any)?.id;
    if (!cleanerId) {
      toast.error("Please select a cleaner");
      return;
    }
    const start_time = selectedStartTime || data?.start_time || jobDraft?.from;
    const end_time = selectedEndTime || (data as any)?.end_time || jobDraft?.to;
    const rate = selectedRate ?? data?.rate;
    const scheduleDateValue = data?.schedule_date || jobDraft?.schedule_date;
    if (isPastStartTime(start_time, scheduleDateValue)) {
      toast.error(
        intl.formatMessage({
          id: "INDIVIDUAL.TIME.ERROR.START_PAST",
          defaultMessage:
            "Selected start time has already passed. Please choose a future time.",
        }),
      );
      return;
    }
    if (
      end_time &&
      start_time &&
      toMinutes(end_time) <= toMinutes(start_time)
    ) {
      toast.error(
        intl.formatMessage({
          id: "INDIVIDUAL.TIME.ERROR.END_AFTER_START",
          defaultMessage: "End time must be after start time.",
        }),
      );
      return;
    }
    if (
      appSettingsData &&
      appSettingsData?.isPlatformPaymentActive != undefined &&
      appSettingsData?.isPlatformPaymentActive === true &&
      (!selectedPaymentMethod || !selectedPaymentMethod?.id)
    ) {
      toast.error(
        intl.formatMessage({
          id: "VALIDATION.PAYMENTMETHOD.NOT.FOUND",
          defaultMessage: "Please select payment method",
        }),
      );
      return;
    }

    let jobIdentifier = jobId;
    if (jobId && jobId !== "draft") {
      const res = await updateJob({
        id: jobId,
        start_time,
        end_time,
        rate,
        cleaner_id: cleanerId,
        work_status: "active",
      });
      if (!res?.success) {
        toast.error("Unable to confirm the job. Please try again.");
        return;
      }
      setData(res?.data);
      if (res?.data?.cleaner_id) {
        setCleanerData(res?.data?.cleaner_id);
      }
      jobIdentifier = jobId;
    } else {
      if (!jobDraft) {
        toast.error(
          "Job details missing. Please go back and re-enter your task details.",
        );
        return;
      }
      const res = await addJob({
        ...jobDraft,
        start_time,
        end_time,
        rate,
        cleaner_id: cleanerId,
        work_status: "active",
        payment_method: selectedPaymentMethod?.id || "",
      });
      if (!res?.success) {
        console.log("res?.data?.msg", res?.data?.msg);
        if (res?.data?.msg == "PAYMENTMETHOD.NOT.FOUND") {
          toast.error(
            intl.formatMessage({
              id: "API.ERROR.PAYMENTMETHOD.NOT.FOUND",
              defaultMessage: "Please set up your payment method first",
            }),
          );
        } else if (res?.data?.msg == "PAYMENTMETHOD.DEFAULT.NOT.FOUND") {
          toast.error(
            intl.formatMessage({
              id: "API.ERROR.PAYMENTMETHOD.DEFAULT.NOT.FOUND",
              defaultMessage: "Please set a default payment method first",
            }),
          );
        } else if (res?.data?.msg == "SELECT.PAYMENTMETHOD") {
          toast.error(
            intl.formatMessage({
              id: "API.ERROR.PAYMENTMETHOD.DEFAULT.NOT.FOUND",
              defaultMessage: "Please set a default payment method first",
            }),
          );
        } else {
          toast.error("Unable to confirm the job. Please try again.");
        }
        return;
      }
      setData(res?.data);
      if (res?.data?.cleaner_id) {
        setCleanerData(res?.data?.cleaner_id);
      } else if (cleanerData) {
        setCleanerData(cleanerData);
      }
      jobIdentifier = res?.data?.id || (res as any)?.data?._id;
      if (!jobIdentifier) {
        toast.error("Unable to confirm the job. Please try again.");
        return;
      }
      setJobId(jobIdentifier);
    }

    const payload = {
      message: `${userData?.first_name} ${userData?.last_name} wants to hire you`,
      recipient_id: cleanerId,
      sender_id: userId,
      individual_job_id: jobIdentifier,
      type: "job_offered",
      sender_id_type: "individual",
      recipient_id_type: "cleaner",
    };
    socket.emit("sendmessage", payload); // Match the event name in the backend
    navigate(`/individual/confirm-and-chat/${jobIdentifier}`);
  };

  useEffect(() => {
    if (cardDetails && cardDetails.length > 0) {
      const getdefaultpaymentmethod = cardDetails.find(
        (item) => item?.isDefault,
      );
      setSelectedPaymentMethod(getdefaultpaymentmethod || cardDetails[0]);
    }
    return () => {};
  }, [cardDetails]);

  const topHeader = (
    <div className="bg-white flex justify-center w-full space-x-2 border border-neutral-200 py-3">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
        />
      </svg>
      <p>
        <FormattedMessage
          id="INDIVIDUAL.REVIEW_TASK.TOP.TEXT"
          defaultMessage="You're almost done. We just need a few more details to connect you with your cleaner."
        />
      </p>
    </div>
  );
  return (
    <MainWrapper topHeader={topHeader}>
      <ContentWithSpinner height="h-screen" loader={loader === "JobData"}>
        <div className="py-6 lg:px-14 mx-auto max-w-[60rem]">
          <div className="lg:grid lg:grid-cols-12 lg:gap-5">
            <div className="col-span-7">
              <div className="bg-white border border-neutral-300 rounded-lg px-3 lg:mb-0 h-fit pb-3">
                <p className="text-base  py-3">
                  <FormattedMessage
                    id="INDIVIDUAL.REVIEW_TASK.TITLE"
                    defaultMessage="Review your task description"
                  />
                </p>
                <div className="border border-neutral-500 rounded-lg p-2 h-28">
                  <p>{data?.description}</p>
                </div>
                <div>
                  <p className="text-base  py-3">
                    <FormattedMessage
                      id="INDIVIDUAL.REVIEW_TASK.PAYMENT_METHOD.TITLE"
                      defaultMessage="Payment method"
                    />
                  </p>
                  <div>
                    <FormattedMessage
                      id="INDIVIDUAL.REVIEW_TASK.PAYMENT_METHOD.DESCRIPTION"
                      defaultMessage="You may see a temporary hold on your payment method in the amount of your Tasker's hourly rate. Don't worry - you'r only billed when your task is complete."
                    />
                  </div>
                </div>

                <div className="relative" ref={paymentDropdownRef}>
                  <div className="flex items-center space-x-3 py-3 pl-3">
                    {getCardIcon(
                      selectedPaymentMethod &&
                        selectedPaymentMethod?.id &&
                        selectedPaymentMethod?.card?.brand,
                    )}
                    <span>
                      **** **** ****{" "}
                      {selectedPaymentMethod &&
                        selectedPaymentMethod?.id &&
                        selectedPaymentMethod?.card?.last4}
                    </span>
                  </div>
                  {cardDetails?.length > 0 && (
                    <p
                      className="text-base text-[#0078ae] cursor-pointer mb-5 select-none"
                      role="button"
                      tabIndex={0}
                      aria-expanded={showPaymentDropdown}
                      onClick={() => setShowPaymentDropdown((prev) => !prev)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          setShowPaymentDropdown((prev) => !prev);
                        }
                      }}
                    >
                      <FormattedMessage
                        id="INDIVIDUAL.REVIEW_TASK.CHANGE_PAYMENT"
                        defaultMessage="Change payment"
                      />
                    </p>
                  )}
                  {showPaymentDropdown && cardDetails?.length > 0 && (
                    <div className="absolute z-20 top-full left-0 w-full max-w-xs bg-white border border-neutral-300 rounded-lg shadow-lg overflow-hidden">
                      {cardDetails.map((card: any) => {
                        const isSelected =
                          selectedPaymentMethod?.id === card?.id;
                        return (
                          <div
                            key={card?.id}
                            role="option"
                            aria-selected={isSelected}
                            className={`flex items-center justify-between space-x-3 px-3 py-2 cursor-pointer hover:bg-neutral-100 ${
                              isSelected ? "bg-neutral-50" : ""
                            }`}
                            onClick={() => {
                              setSelectedPaymentMethod(card);
                              setShowPaymentDropdown(false);
                            }}
                          >
                            <div className="flex items-center space-x-3">
                              {getCardIcon(card?.card?.brand)}
                              <span>**** **** **** {card?.card?.last4}</span>
                            </div>
                            {isSelected && (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={2}
                                stroke="currentColor"
                                className="w-4 h-4 text-[#0078ae]"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M4.5 12.75l6 6 9-13.5"
                                />
                              </svg>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
                {/* <p className="text-base  text-[#0078ae] cursor-pointer mb-5"><FormattedMessage id="INDIVIDUAL.REVIEW_TASK.PROMO" defaultMessage="Do you have a promo code?" /></p> */}
                <div className="border border-neutral-300 w-full"></div>
                <img
                  className="my-6"
                  src={toAbsoluteUrl("/media/logos/logo2.png")}
                  alt=""
                />
                <div className="text-xs">
                  <FormattedMessage
                    id="INDIVIDUAL.REVIEW_TASK.BOTTOM.TEXT"
                    defaultMessage="Join us in helping our neighbors in need find work and a place to call home."
                  />
                </div>
                <a
                  className="mt-2 text-sm font-bold  text-[#0078ae]  cursor-pointer underline"
                  href="https://janijobs.com/for-residential/"
                >
                  <FormattedMessage
                    id="INDIVIDUAL.REVIEW_TASK.LEARN_MORE.BUTTON"
                    defaultMessage="Learn More"
                  />
                </a>
              </div>
              <div className="flex justify-center mt-3 mb-3">
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    HandleMessage();
                  }}
                  className="text-center rounded-full font-bold bg-[#ff39b3] px-5 py-2  text-white cursor-pointer hover:bg-navy"
                >
                  <FormattedMessage
                    id="INDIVIDUAL.REVIEW_TASK.CONFIRM.BUTTON"
                    defaultMessage="Confirm and Chat"
                  />
                </Link>
              </div>
            </div>
            <div className="col-span-5">
              <div className="bg-white border border-neutral-300 rounded-lg mb-3 lg:mb-3">
                <div className="bg-[#F3F2F1]">
                  <p className="text-base  text-center mb-2">{data?.title}</p>
                  <div className="flex justify-center mb-2">
                    <img
                      alt="Profile"
                      className="rounded-full w-16 h-16"
                      src={
                        profileImg
                          ? profileImg
                          : toAbsoluteUrl(
                              "/media/icons/displayProfilePlaceholder.png",
                            )
                      }
                    />
                  </div>
                  <div className="text-sm text-center w-full">
                    {(cleanerData as any)?.first_name ||
                      (data as any)?.cleaner_id?.first_name}{" "}
                    {(cleanerData as any)?.last_name ||
                      (data as any)?.cleaner_id?.last_name}
                  </div>
                </div>
                <ul className="px-3 py-3">
                  <li className="mb-3">
                    <div className="flex space-x-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-6 h-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"
                        />
                      </svg>
                      <div>
                        {DateFormat(data?.schedule_date)} at{" "}
                        {StringTimeFormat(selectedStartTime)} -{" "}
                        {StringTimeFormat(selectedEndTime)}
                      </div>
                    </div>
                  </li>
                  <li className="mb-3">
                    <div className="flex space-x-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-6 h-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
                        />
                      </svg>
                      <div>
                        {data?.streetAddress} {data?.unitorapt}
                      </div>
                    </div>
                  </li>
                </ul>
                {/* <div className="flex justify-start px-3">
                <div className="cursor-pointer  border border-[#0078ae] text-[#0078ae] py-2 px-3 rounded-full my-3"><FormattedMessage id="INDIVIDUAL.REVIEW_TASK.EDITTASK.BUTTON" defaultMessage="Edit Task" /></div>
                </div> */}
              </div>
              <div className="bg-white border border-neutral-300 rounded-lg mb-3 lg:mb-0 px-3 pb-3">
                <div className="flex justify-between w-full  text-base my-5">
                  <div>
                    <FormattedMessage
                      id="INDIVIDUAL.REVIEW_TASK.HOURLYRATE.TITLE"
                      defaultMessage="Hourly Rate"
                    />
                  </div>
                  <div>
                    $
                    {Number(
                      selectedRate ?? data?.rate ?? jobDraft?.rate,
                    )?.toFixed(2)}
                    /hr
                  </div>
                </div>
                {feeTransparencyLoading || feeTransparency ? (
                  <div className="mt-2">
                    <div className="text-xs font-medium text-neutral-600 mb-2">
                      Estimated
                    </div>
                    <FeeBreakdownBox
                      className="mt-0"
                      loading={feeTransparencyLoading}
                      rows={[
                        {
                          label: "Service amount",
                          value: Number(feeTransparency?.amount || 0),
                        },
                        {
                          label: "Service fee",
                          value: Number(
                            feeTransparency?.job_provider_fee_amount || 0,
                          ),
                        },
                      ]}
                      totalLabel="Total payable"
                      totalValue={Number(
                        feeTransparency?.job_provider_paid_amount || 0,
                      )}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </ContentWithSpinner>
    </MainWrapper>
  );
};
